import { render, staticRenderFns } from "./MessageIncomingSticker.vue?vue&type=template&id=64331e70&"
import script from "./MessageIncomingSticker.vue?vue&type=script&lang=js&"
export * from "./MessageIncomingSticker.vue?vue&type=script&lang=js&"
import style0 from "./MessageIncomingSticker.vue?vue&type=style&index=0&id=64331e70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
